import { State } from "src/interfaces/State"
import { RequestState } from "src/interfaces/RequestState"

export const isError = (state : State, types : string[]) : boolean => {
    return getRequestsByList(state, types)
        .some(request => request.error);
}

export const isSuccessful = (state : State, types : string[]) : boolean => {
    if (getRequestsByList(state, types).length == 0){
        return false;
    }

    return getRequestsByList(state, types)
        .every(request => request.success);
}

export const getRequestsByList = (state : State, types : string[]) : RequestState[] => {
    return types.map(action => state.requests[action] || {success: false, error: false, pending: false} as RequestState);
}


export const isPending = (state : State, types : string[]) : boolean => {
    if (getRequestsByList(state, types).length == 0){
        return false;
    }

    return getRequestsByList(state, types)
        .every(request => request.pending);
}